import { useLocation, useNavigate } from 'react-router-dom'
import { COLOR } from 'src/constants/colors'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import Div from 'src/components/atomic/atom/Div'
import { RootState } from 'src/store/store'
import { commonUtils } from 'src/utils/common.utils'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import Image from 'src/components/atomic/atom/Image'
import mo_main_logo from 'src/assets/imgs/logo/mo_main_logo.png'
import useMatchHook from 'src/hooks/useMatch.hook'

const MoMenu = () => {
  const navigate = useNavigate()
  const { setMediaStyle } = useMediaQueryHook()
  const { pathname } = useLocation()
  const { m_setting, m_location_detail, m_explorer_delete, m_explorer_detail } = useMatchHook()
  const { BatteryInfo, SvgName } = useAppSelector((state: RootState) => state.isBattery)
  const { selectPin } = useAppSelector((state: RootState) => state.LocationPage)
  const { setDateFormat } = commonUtils

  //explorer 페이지헤더는 따로 있음.

  const MenuTitle = () => {
    switch (pathname) {
      case m_setting?.pathname:
        return 'Setting'
      case m_location_detail?.pathname:
        return setDateFormat('LOCATION_DETAIL', selectPin?.Date as number)
      default:
        return false
    }
  }

  const ExceptionMoMenuDesign = () => {
    return (
      <>
        <Svg name={'reverse_arrow'} $margin={'13px 0'} onClick={() => navigate(-1)} />
        <Span $line_height={'48px'} option={'tiny_bold'}>
          {MenuTitle()}
        </Span>
      </>
    )
  }

  const DefaultMoMenuDesign = () => {
    return (
      <>
        <Image $ImgSrc={mo_main_logo} $margin={'12px 0'} width={'28px'} height={'24px'} />
        <Div display={'flex'}>
          <Span fontSize={'10px'} $line_height={'48px'} color={COLOR.black80}>
            {BatteryInfo && BatteryInfo + '%'}
          </Span>
          <Svg name={SvgName.mo} $margin={'15.5px 0 15.5px 5px'} />
          <Svg
            name={'setting'}
            width={'24'}
            height={'24'}
            $margin={'12px 0 12px 11px'}
            onClick={() => navigate('/setting')}
            className={'menu_setting'}
          />
        </Div>
      </>
    )
  }

  return (
    <Div
      style={{
        position: 'absolute',
        zIndex: 9996,
        top: 0,
        left: '50%',
        transform: 'translate(-50%, 0)',
        background: MenuTitle() ? 'rgba(255, 255, 255, 0.9)' : COLOR.white,
        backdropFilter: MenuTitle() ? 'blur(2px)' : 'unset',
      }}
      display={setMediaStyle(
        'none',
        !m_explorer_detail && !m_explorer_delete ? 'flex' : 'none',
        !m_explorer_detail && !m_explorer_delete ? 'flex' : 'none',
      )}
      $position={'absolute'}
      $justify_content={'space-between'}
      width={'100%'}
      $padding={'0 20px'}
      height={'48px'}
      $margin={'0 auto'}
      $bgColor={COLOR.white}
    >
      {MenuTitle() ? <ExceptionMoMenuDesign /> : <DefaultMoMenuDesign />}
    </Div>
  )
}
export default MoMenu
